import { FieldRenderProps } from 'react-final-form'
import DatesPicker, { ValueDatetime } from '../../control/DatePicker'

type SelectInputProps = FieldRenderProps<ValueDatetime, any>

const DatePickerInput: React.FC<SelectInputProps> = ({ input, meta, ...rest }) => {
    return <DatesPicker {...input} {...rest} error={meta.touched && meta.error} helperText={meta.error} />
}

export default DatePickerInput
